/* MetalWorksMorocco product gallery (Etsy-style). Pairs with snippets/mwm-gallery.liquid */
(function () {
  if (customElements.get('mwm-gallery')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class MwmGallery extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.track = this.querySelector('.mwm-g__track');
      this.slides = Array.from(this.querySelectorAll('.mwm-g__slide'));
      this.thumbs = Array.from(this.querySelectorAll('.mwm-g__thumb'));
      this.thumbList = this.querySelector('.mwm-g__thumbs');
      this.countEl = this.querySelector('.mwm-g__count-current');
      this.index = -1;

      const prev = this.querySelector('.mwm-g__nav--prev');
      const next = this.querySelector('.mwm-g__nav--next');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.go(Number(thumb.dataset.go)));
      });

      // While an arrow/thumbnail move is animating, ignore intermediate scroll positions;
      // when scrolling settles, make sure we landed exactly on the target photo.
      this.target = null;
      this.track.addEventListener('scroll', () => {
        clearTimeout(this._settle);
        this._settle = setTimeout(() => this.onScrollSettled(), 140);
        if (this.target !== null) return;
        cancelAnimationFrame(this._raf);
        this._raf = requestAnimationFrame(() => this.syncFromScroll());
      }, { passive: true });
      ['pointerdown', 'touchstart', 'wheel'].forEach((type) => {
        this.track.addEventListener(type, () => { this.target = null; }, { passive: true });
      });

      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + 1); }
      });

      this.slides.forEach((slide, i) => {
        const zoom = slide.querySelector('[data-open]');
        if (zoom) zoom.addEventListener('click', () => this.openViewer(i));
        const play = slide.querySelector('[data-play]');
        if (play) play.addEventListener('click', () => this.playVideo(slide));
      });

      this.setupViewer();

      // Keep the same photo in view if the stage is resized (rotation, window resize)
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => {
          if (this.index >= 0) this.track.scrollLeft = this.index * this.track.clientWidth;
        }).observe(this.track);
      }

      const start = Math.min(Number(this.dataset.start) || 0, this.slides.length - 1);
      this.go(start, false);
    }

    go(i, smooth = true) {
      const n = this.slides.length;
      if (!n) return;
      i = ((i % n) + n) % n;
      const left = i * this.track.clientWidth;
      const animate = smooth && !reduceMotion.matches && Math.abs(this.track.scrollLeft - left) > 1;
      this.target = animate ? i : null;
      this.track.scrollTo({ left, behavior: animate ? 'smooth' : 'auto' });
      this.mark(i);
      if (animate) {
        clearTimeout(this._settle);
        this._settle = setTimeout(() => this.onScrollSettled(), 700);
      }
    }

    onScrollSettled() {
      const width = this.track.clientWidth;
      if (!width) return;
      if (this.target !== null) {
        const left = this.target * width;
        this.target = null;
        if (Math.abs(this.track.scrollLeft - left) > 1) this.track.scrollTo({ left, behavior: 'auto' });
        return;
      }
      const i = Math.round(this.track.scrollLeft / width);
      if (Math.abs(this.track.scrollLeft - i * width) > 1) this.track.scrollTo({ left: i * width, behavior: 'auto' });
      this.mark(i);
    }

    syncFromScroll() {
      const width = this.track.clientWidth;
      if (!width) return;
      const i = Math.round(this.track.scrollLeft / width);
      if (i !== this.index && i >= 0 && i < this.slides.length) this.mark(i);
    }

    mark(i) {
      if (i === this.index) return;
      this.index = i;
      if (this.countEl) this.countEl.textContent = String(i + 1);

      this.thumbs.forEach((thumb, t) => {
        const active = t === i;
        thumb.classList.toggle('is-active', active);
        if (active) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      this.revealThumb(this.thumbs[i]);
      this.pauseOthers(i);
    }

    // Scroll the thumbnail list (not the page) so the active thumb is visible
    revealThumb(thumb) {
      if (!thumb || !this.thumbList) return;
      const list = this.thumbList;
      const item = thumb.parentElement;
      const vertical = list.scrollHeight > list.clientHeight + 2 && getComputedStyle(list).flexDirection === 'column';
      if (vertical) {
        const top = item.offsetTop - list.offsetTop;
        if (top < list.scrollTop) list.scrollTop = top - 4;
        else if (top + item.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = top + item.offsetHeight - list.clientHeight + 4;
      } else {
        const left = item.offsetLeft - list.offsetLeft;
        if (left < list.scrollLeft) list.scrollLeft = left - 4;
        else if (left + item.offsetWidth > list.scrollLeft + list.clientWidth) list.scrollLeft = left + item.offsetWidth - list.clientWidth + 4;
      }
    }

    playVideo(slide) {
      const template = slide.querySelector('template');
      const poster = slide.querySelector('[data-play]');
      if (!template || !poster) return;
      const media = template.content.firstElementChild.cloneNode(true);
      poster.replaceWith(media);
      if (media.tagName === 'VIDEO') media.play().catch(() => {});
    }

    pauseOthers(activeIndex) {
      this.slides.forEach((slide, i) => {
        if (i === activeIndex) return;
        const video = slide.querySelector('video');
        if (video) video.pause();
        const frame = slide.querySelector('iframe');
        if (frame && frame.contentWindow) {
          frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          frame.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      });
    }

    // Called by the theme's variant picker (global.js VariantSelects.updateMedia)
    setActiveMedia(mediaId) {
      const i = this.slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
      if (i > -1) this.go(i);
    }

    /* ---------- Full-screen viewer ---------- */
    setupViewer() {
      this.dialog = this.querySelector('.mwm-lb');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

      this.viewerSlides = this.slides
        .map((slide, i) => ({ i, src: slide.dataset.full, alt: slide.dataset.alt || '' }))
        .filter((item) => item.src);
      this.viewerImg = this.dialog.querySelector('.mwm-lb__img');
      this.viewerCount = this.dialog.querySelector('.mwm-lb__count');
      this.dialog.classList.toggle('is-single', this.viewerSlides.length < 2);

      this.dialog.querySelector('.mwm-lb__close').addEventListener('click', () => this.dialog.close());
      this.dialog.querySelector('.mwm-lb__nav--prev').addEventListener('click', () => this.viewerStep(-1));
      this.dialog.querySelector('.mwm-lb__nav--next').addEventListener('click', () => this.viewerStep(1));

      // Click on the dark area around the photo closes the viewer
      this.dialog.querySelector('.mwm-lb__viewport').addEventListener('click', (event) => {
        if (event.target === event.currentTarget && !this.dialog.classList.contains('is-zoomed')) this.dialog.close();
      });

      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.viewerStep(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.viewerStep(1); }
      });

      this.dialog.addEventListener('close', () => {
        this.setZoom(false);
        document.documentElement.style.overflow = '';
        const current = this.viewerSlides[this.viewerPos];
        if (current) this.go(current.i, false);
      });

      // Zoom on click; when zoomed, the photo follows the pointer
      let downX = 0;
      let downY = 0;
      let swiped = false;
      this.viewerImg.addEventListener('pointerdown', (event) => {
        downX = event.clientX;
        downY = event.clientY;
        swiped = false;
      });
      this.viewerImg.addEventListener('pointerup', (event) => {
        if (this.dialog.classList.contains('is-zoomed')) return;
        const dx = event.clientX - downX;
        const dy = event.clientY - downY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          swiped = true;
          this.viewerStep(dx < 0 ? 1 : -1);
        }
      });
      this.viewerImg.addEventListener('click', (event) => {
        if (swiped) { swiped = false; return; }
        const zoomed = !this.dialog.classList.contains('is-zoomed');
        this.setZoom(zoomed);
        if (zoomed) this.panTo(event);
      });
      this.viewerImg.addEventListener('pointermove', (event) => {
        if (this.dialog.classList.contains('is-zoomed')) this.panTo(event);
      });
    }

    panTo(event) {
      const rect = this.viewerImg.getBoundingClientRect();
      const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
      const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
      this.viewerImg.style.transformOrigin = `${x}% ${y}%`;
    }

    setZoom(on) {
      this.dialog.classList.toggle('is-zoomed', on);
      if (!on) this.viewerImg.style.transformOrigin = '';
    }

    openViewer(slideIndex) {
      if (!this.dialog || !this.viewerSlides || !this.viewerSlides.length) return;
      const pos = this.viewerSlides.findIndex((item) => item.i === slideIndex);
      this.viewerPos = pos > -1 ? pos : 0;
      this.renderViewer();
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
      this.dialog.querySelector('.mwm-lb__close').focus();
    }

    viewerStep(delta) {
      const n = this.viewerSlides.length;
      if (n < 2) return;
      this.setZoom(false);
      this.viewerPos = (((this.viewerPos + delta) % n) + n) % n;
      this.renderViewer();
    }

    renderViewer() {
      const n = this.viewerSlides.length;
      const item = this.viewerSlides[this.viewerPos];
      // Show the photo already loaded on the page right away, then swap in the sharp version
      const onPage = this.slides[item.i] && this.slides[item.i].querySelector('img');
      const quick = onPage && onPage.complete && onPage.currentSrc;
      const token = (this._viewerToken = (this._viewerToken || 0) + 1);
      if (quick) {
        this.viewerImg.src = quick;
        const sharp = new Image();
        sharp.onload = () => { if (token === this._viewerToken) this.viewerImg.src = item.src; };
        sharp.src = item.src;
      } else {
        this.viewerImg.src = item.src;
      }
      this.viewerImg.alt = item.alt;
      this.viewerCount.textContent = `${this.viewerPos + 1} / ${n}`;
      // Warm up the neighbours so arrows feel instant
      [1, -1].forEach((d) => {
        const neighbour = this.viewerSlides[(((this.viewerPos + d) % n) + n) % n];
        if (neighbour && neighbour !== item) new Image().src = neighbour.src;
      });
    }
  }

  customElements.define('mwm-gallery', MwmGallery);
})();
